var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkedinCircularFilled = function SvgLinkedinCircularFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.651 20.985H6.384v-10.5h3.267v10.5ZM8.018 9.05a1.892 1.892 0 1 1-.003-3.784 1.892 1.892 0 0 1 .003 3.784Zm13.857 11.935h-3.264V15.88c0-1.217-.02-2.784-1.695-2.784-1.699 0-1.958 1.326-1.958 2.697v5.193h-3.26v-10.5h3.129v1.435h.044c.436-.825 1.5-1.696 3.089-1.696 3.304 0 3.915 2.174 3.915 5.002v5.76Z",
    fill: "#fff"
  })));
};

export default SvgLinkedinCircularFilled;